var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"request-home"},[_c('vue-qrcode',{attrs:{"value":_vm.url,"width":"300"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }